import React, {
  useState,
  useCallback,
  useContext,
  useEffect,
} from 'react';
import ReactTooltip from 'react-tooltip';
import { Button, Input } from '@mymoons/ui-library';
import { Box } from '../../../../components';
import styles from '../../Summary.module.css';
import {
  axiosPutAddCoupon,
  axiosPutRemoveCoupon,
} from '../../../../methods/globalData/axiosPut';
import { close } from '../../../../assets/images/Global';
import ProductContext from '../../../../context/Product/Context';
import totalPriceCarts from '../../../../hooks/totalCarts';
import PaymentContext from '../../../../context/Payment/Context';
import stylesTooltip from '../../../Payment/Payment.module.css';
import convertPrice from '../../../../hooks/convertPrice';

const Coupon = () => {
  const carts = new URLSearchParams(window.location.search).getAll('cart');
  const productContext = useContext(ProductContext);
  const paymentContext = useContext(PaymentContext);
  const [inputCoupon, setInputCoupon] = useState(true);
  const [coupon, setCoupon] = useState('');
  const [couponError, setCouponError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [hasCoupon, setHasCoupon] = useState(false);
  const [originalPrice, setOriginalPrice] = useState(0);
  const [lineItemsNew, setLineItems] = useState([]);
  const [lineItemsOriginal, setLineItemsOriginal] = useState([]);
  const [disableApply, setDisableApply] = useState(true);
  const {
    carts: cartsNew,
    setCarts,
    couponsCode,
    setCoupons,
    setCouponsCode,
    setProductsWithDiscount,
  } = productContext;
  const { address } = paymentContext;
  const totalPrice = totalPriceCarts(cartsNew, false);
  let cost = 0;
  const disabledCoupon = address.ChangePaymentType;

  const handleSubmit = useCallback(
    async (e) => {
      setLoader(true);
      e.preventDefault();
      e.stopPropagation();
      setCouponError(null);
      axiosPutAddCoupon(carts[0], coupon)
        .then((res) => {
          setLineItems([...lineItemsNew, res.data.lineItems]);
          setCarts([res.data]);
          setCoupons(res.data.discountCodes);
          setProductsWithDiscount(res.data.lineItems);
          setCouponsCode([
            ...couponsCode,
            { id: res.data.discountCodes[0].discountCode.id, code: coupon },
          ]);
          setLoader(false);
          setInputCoupon(false);
        })
        .catch(() => {
          setLoader(false);
          setCouponError('El cupón es inválido o ha expirado');
          setTimeout(() => {
            setCouponError(null);
          }, 3000);
        });
    },
    [coupon],
  );

  useEffect(() => {
    if (couponsCode.length > 0) {
      setHasCoupon(true);
      const discount = {
        number: Number(((originalPrice - totalPrice) * 100) / 100).toFixed(2),
        code: couponsCode[0].code,
      };
      localStorage.setItem('discount', JSON.stringify(discount));
    } else {
      setHasCoupon(false);
      localStorage.setItem('discount', JSON.stringify('false'));
    }
  }, [couponsCode]);

  useEffect(() => {
    const { lineItems } = cartsNew[0];
    lineItems.forEach((item) => {
      cost = +cost + (item.price.value.centAmount / 100) * item.quantity;
      setOriginalPrice(originalPrice + cost);
    });
  }, []);

  useEffect(() => {
    if (inputCoupon.length > 1) {
      const inputFocus = document.querySelector('#couponInput');
      inputFocus.focus();
    }
  }, [inputCoupon]);

  useEffect(() => {
    if (coupon.length === 0) {
      setDisableApply(true);
    } else {
      setDisableApply(false);
    }
  }, [coupon]);

  const eraseCoupon = (couponToErase) => {
    const couponReference = {
      typeId: 'discount-code',
      id: couponToErase,
    };
    axiosPutRemoveCoupon(carts[0], couponReference)
      .then((res) => {
        setCarts([res.data]);
        setCouponsCode([]);
        setLineItemsOriginal([...lineItemsOriginal, res.data.lineItems]);
        setProductsWithDiscount([]);
        setCoupons(res.data.discountCodes);
        setCoupon('');
        setLoader(false);
        setInputCoupon(true);
      })
      .catch(() => {
        setLoader(false);
      });
  };

  return (
    <form className={styles.formCoupon} onSubmit={handleSubmit}>
      <Box ai="flex-start">
        {!hasCoupon && !inputCoupon ? (
          <ReactTooltip
            place="top"
            id="tooltip-error-coupon"
            disable={!disabledCoupon}
            effect="solid"
            offset="{'left': 80}"
            className={stylesTooltip.customTooltipAddress}
            backgroundColor="#212121"
          >
            No es posible agregar un cupón una vez realizada una orden
          </ReactTooltip>
        ) : (
          <div className={styles.couponsContainer}>
            {couponsCode.map((code) => {
              return (
                <div className={styles.priceContainer}>
                  <div key={code.id} className={styles.promoContainer}>
                    <span>{code.code}</span>
                    {!disabledCoupon && (
                      <button
                        id="Check_Summary_EraseCoupon"
                        onClick={() => {
                          eraseCoupon(code.id);
                        }}
                        type="button"
                      >
                        <img width={9.33} height={9.33} src={close} alt="Times" />
                      </button>
                    )}
                  </div>
                  <p>{`-${convertPrice(Number(((originalPrice - totalPrice) * 100) / 100).toFixed(2))}`}</p>
                </div>
              );
            })}
          </div>
        )}
        {couponsCode.length < 1 && (
          <div className={styles.containerCoupon}>
            <Input
              id="couponInput"
              className={styles.inputCoupon}
              error={couponError}
              iconVariant="regular"
              label=""
              placeholder="Ingresar cupón"
              value={coupon}
              variant="outline"
              fullWidth
              pattern="[a-zA-Z0-9\-]+"
              onChange={(e) => {
                setCoupon(e.target.value);
              }}
            />
            <Button
              id="Check_Summary_AddCoupon_Action"
              className={styles.couponButton}
              color="red"
              label="Aplicar"
              isButton
              rel="noopener noreferrer"
              size="small"
              variant="text"
              type="submit"
              loading={loader}
              disabled={disableApply}
            />
          </div>
        )}
      </Box>
    </form>
  );
};

export default Coupon;
